// removed by extract-text-webpack-plugin
module.exports = {"light-box-image":"_1boW_9m9kqEAc5FGlXZ4HE","light-box-image--disabled":"_2D9t8CbOfkLy0xv1iFyktP"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/light-box-image.scss
// module id = 13535
// module chunks = 0